import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './GameTablesLayout.module.css';
import 'swiper/css';
import Game from './Game';
import useActiveGames from '@/src/hooks/data/useActiveGames';
import useActiveGame from '@/src/hooks/data/useActiveGame';
import GameTopRow from '@/src/components/GameTopRow/GameTopRow';
import { useDispatch } from 'react-redux';
import { updateActiveGame } from '@/Poker/redux/slices/gameTableSlice';
import { useNavigate } from 'react-router';
import GameToastProvider from '@/src/providers/GameToastProvider';
import GamePopups from '@/src/components/Miscellaneous/GamePopups';

const GameTablesLayout = () => {
    // This will be replaced with actual game data from your state management
    const activeGames = useActiveGames(); // Example game IDs
    const activeGame = useActiveGame();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeDrawer, setActiveDrawer] = useState(null);

    const changeActiveGame = (realIndex) => {
        // This will be replaced with your actual game change logic
        let tempTableId = activeGames[realIndex];
        dispatch(updateActiveGame(tempTableId));
        return;
    };

    useEffect(() => {
        if (activeGames.length === 0) {
            navigate(-1, { replace: true });
        }
    }, [activeGames])

    return activeGames.length > 0 ? (
        <div className={styles.gameTablesContainer}>
            <GameTopRow setActiveDrawer={setActiveDrawer} activeGames={activeGames} activeGame={activeGame} />
            <Swiper
                initialSlide={
                    activeGames.indexOf(activeGame) >= 0
                        ? activeGames.indexOf(activeGame)
                        : 0
                }
                loop={true}
                simulateTouch={activeGames.length > 1}
                slidesPerView={1}
                onRealIndexChange={(details) => changeActiveGame(details?.realIndex)}
            >
                {activeGames.map((tempTableId, index) => (
                    <SwiperSlide className={styles.swiperSlideOverflow} key={`game-${tempTableId}`}>
                        <GameToastProvider tempTableId={tempTableId}>
                            <Game index={index} tempTableId={tempTableId} />
                        </GameToastProvider>
                    </SwiperSlide>
                ))}
            </Swiper>
            <GamePopups tempTableId={activeGame} activeDrawer={activeDrawer} setActiveDrawer={setActiveDrawer} />
        </div>
    ) : null;
};

export default GameTablesLayout;
